module.exports = __webpack_public_path__ + "img/logoImg.6c96ada8.png";